import React from "react";
import { TableCell } from "../../UI/TableCell";
import { TableRow } from "../../UI/TableRow";
import { dateToMMDDYY, getDate } from "../../common/date_utils";
import { ModalProvider } from "../../contexts/ModalContext";
import { UserNameLink } from "../UserNameLink";
import { UserMembershipRemoveButton } from "../UserMembershipRemoveButton";

interface IProps {
  user: Record<string, any>;
  onSuccess?: VoidFunction;
}

export const UserRemoveResultsTableBodyRow: React.FC<IProps> = (props) => {
  const l1Name = props.user.l1IdName || "N/A";
  const l2Name = props.user.l2IdName || "N/A";
  const l3Name = props.user.l3IdName || "N/A";
  const l4Name = props.user.l4IdName || "N/A";

  return (
    <TableRow>
      <TableCell>
        <ModalProvider>
          <UserNameLink name={props.user.name} id={props.user.id} openNewTab />
        </ModalProvider>
      </TableCell>
      <TableCell>{props.user.email}</TableCell>
      <TableCell>{props.user.id}</TableCell>
      <TableCell>{l1Name}</TableCell>
      <TableCell>{l2Name}</TableCell>
      <TableCell>{l3Name}</TableCell>
      <TableCell>{l4Name}</TableCell>
      <TableCell>{props.user.registered ? "Yes" : "No"}</TableCell>
      <TableCell>{props.user.claimedDate && dateToMMDDYY(getDate(props.user.claimedDate))}</TableCell>
      <TableCell align="right">
        <UserMembershipRemoveButton id={props.user.id} name={props.user.name} onSuccess={props.onSuccess} />
      </TableCell>
    </TableRow>
  );
};

